export default __webpack_public_path__ + "images/onfido-logo_3N2AY.svg";